module.exports = __webpack_public_path__ + "static/bootstrap-breadcrumb-basic-cf2cec9b112f0cd8d1a51ec018f91acb.png";